import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { bannerHref } from "./bannerLink";
import styles from "./HomeBannerCarousel.module.css";

function BannerPicture({ banner, eager }) {
  return (
    <picture className={styles.picture}>
      {banner.image_mobile_url && <source media="(max-width: 700px)" srcSet={banner.image_mobile_url} />}
      <img
        src={banner.image_url}
        alt={banner.title || "Gold Loterías"}
        className={styles.image}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
      />
    </picture>
  );
}

function BannerSlide({ banner, eager }) {
  const target = bannerHref(banner.link);
  const pic = <BannerPicture banner={banner} eager={eager} />;
  if (!target) return pic;
  if (target.external) {
    return (
      <a href={target.href} target="_blank" rel="noopener noreferrer" className={styles.link}>
        {pic}
      </a>
    );
  }
  return (
    <Link to={target.href} className={styles.link}>
      {pic}
    </Link>
  );
}

/**
 * Carrusel principal del home con los banners del admin (posición HOME_TOP).
 * Un solo banner se muestra fijo; varios rotan cada 5 s (se pausa al pasar el mouse).
 */
export default function HomeBannerCarousel({ banners }) {
  if (!banners?.length) return null;
  if (banners.length === 1) {
    return (
      <section className={styles.wrap} aria-label="Promociones destacadas">
        <BannerSlide banner={banners[0]} eager />
      </section>
    );
  }
  return (
    <section className={styles.wrap} aria-label="Promociones destacadas">
      <Swiper
        modules={[Autoplay, Pagination]}
        loop
        autoplay={{ delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true }}
        pagination={{ clickable: true }}
        className={styles.swiper}
      >
        {banners.map((b, i) => (
          <SwiperSlide key={b.id || i}>
            <BannerSlide banner={b} eager={i === 0} />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
